import $ from "jquery";

const _faqQuestion = $('.block-faq__question');
const _faqCategoryList = $('.block-faq-category-list__headline');

const openCloseFAQ = function(e) {
    e.preventDefault();
    const $parent = $(this).parent();
    
    if ($parent.hasClass("block-question--open")) {
        // Immediately close without animation
        $parent.removeClass("block-question--open");
    } else {
        // Open panel immediately and let CSS handle content animation
        $parent.addClass("block-question--open");
    }
}

const openCloseFAQCategroryList = function(e) {
    console.log("openCloseFAQCategroryList");
    e.preventDefault();
    const $parent = $(this).parent();
    if ($parent.hasClass("block-faq-category-list--open")) {
        // Immediately close without animation
        $parent.removeClass("block-faq-category-list--open");
    } else {
        // Open panel immediately and let CSS handle content animation
        $parent.addClass("block-faq-category-list--open");
    }
}

export const initFAQs = function() {
    _faqQuestion.on("click", openCloseFAQ);
    _faqCategoryList.on("click", openCloseFAQCategroryList);
};